import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from "react-infinite-scroll-component";

export const PublicationsSection = ({ publicationsData, profile, hasCustomDomain }) => {
    const isotopeRef = useRef();
    const [postsPerPage, setPostsPerPage] = useState(6);
    const [blogData, setBlogData] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    useEffect(() => {
        loadInitialData();
    }, [publicationsData]);

    // Function to load initial data
    const loadInitialData = () => {
        // Slice the initial posts
        const firstPosts = Object?.keys(publicationsData?.length > 0 && publicationsData)?.slice(0, postsPerPage);
        const initialData = firstPosts?.map((post) => publicationsData[post]);
        setBlogData(initialData);
    };

    // Function to fetch more data
    const fetchMoreData = () => {
        if (postsPerPage >= Object?.keys(publicationsData?.length > 0 && publicationsData).length) {
            setHasMore(false);
            return;
        }

        // Simulate loading delay
        const offset = postsPerPage + 2;
        setTimeout(() => {
            const nextPosts = Object?.keys(publicationsData?.length > 0 && publicationsData).slice(
                postsPerPage,
                offset
            );
            const newData = nextPosts?.map((post) => publicationsData[post]);

            setBlogData([...blogData, ...newData]);
            setPostsPerPage(offset);
        }, 1000);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { month: "short", day: "2-digit", year: "numeric" };
        return new Intl.DateTimeFormat("en-US", options).format(date);
    };

    return (
        <div className={`masonry-section articlesDetail`}>
            <InfiniteScroll
                className={"infiniteScroll"}
                dataLength={blogData.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={""}
                scrollableTarget="homeContent"
            >
                {(blogData && blogData.length > 0) && 
                    <div className="articlesList">
                        {blogData.map((blog) => (
                            <div className='isotopeItem' key={blog._id} >
                                <div className='blogItem'>
                                    <div className='blogImage'>
                                        <a
                                            href={
                                                (blog?.publication_type === "Link") ? `${blog?.share_url}`
                                                : (blog?.publication_type === "File") ? `${ blog?.cropImage ? Object.values(blog?.cropImage).find(url => url !== 0) : ''}`
                                                    : (hasCustomDomain) ? `/${blog.url_address}` : `https://jourmal-next-front.vercel.app/${profile}/${blog.url_address}`
                                            }
                                            rel="noreferrer"
                                            target="_blank"
                                        >
                                            <img
                                                src={blog?.fetureImage}
                                                alt={blog.title}
                                                fill={false}
                                                quality={100}
                                                width={500}
                                                height={300}
                                                priority
                                            />
                                        </a>
                                        <div className='blogTypeWrapper'>
                                            <div className='blogType'>
                                                { blog?.publication_type === 'Images' ? 'Gallery' :
                                                    blog?.publication_type === 'File' ? 'File' :
                                                    blog?.publication_type === 'Link' ? 'Link' :
                                                    blog?.publication_type === 'Video' ? 'Video' : 'Publication'
                                                }
                                            </div>

                                            <div className="corner-top-left top">
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                                                </svg>
                                            </div>
                                            <div className="corner-top-left bottom">
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='blogData'> 
                                        <h2 className='blogIitle'>
                                            <a
                                                href={
                                                    (blog?.publication_type === "Link") ? `${blog?.share_url}`
                                                    : (blog?.publication_type === "File") ? `${ blog?.cropImage ? Object.values(blog?.cropImage).find(url => url !== 0) : ''}`
                                                        : (hasCustomDomain) ? `/${blog.url_address}` : `https://jourmal-next-front.vercel.app/${profile}/${blog.url_address}`
                                                }
                                                rel="noreferrer"
                                                target="_blank"
                                            >
                                                {blog.title}
                                            </a>
                                        </h2>                                       
                                        <p className='blogDate'>
                                            {formatDate(blog.createdAt)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>        
                }
            </InfiniteScroll>

        </div>
    )
}
